import { createContext, useContext, useEffect, useState } from "react";
import { useNetwork } from "./Network";
import apiClient, { IEventStats } from "../Services/ApiClient";
import { EventCheckMode, eventStore } from "../Services/EventsStore";
import { appSettings } from "../AppSettings";
import session from "../Services/Session";
import { useOperation } from "./OperationContext";


var lastStats = {} as IEventStats;   
var lastStatsBySector = [] as IEventStats[];    
var mode: EventCheckMode;
var isMounted = false;
var bySector = false;

interface IEventStatsContext {

    updateAsync(isRefresh?: boolean): Promise<void>;

    readonly mode: EventCheckMode;  

    readonly lastUpdate: Date;

    readonly lastStats: IEventStats;    

    readonly lastStatsBySector: IEventStats[];

    readonly eventId: string; 

    bySector: boolean;
}


export const EventStatsContext = createContext({} as IEventStatsContext);

export function useEventStats(bySector = undefined) {

    const result = useContext(EventStatsContext);
    if (bySector !== undefined)
        result.bySector = bySector;
    return result;
}

export function useEventStatsProvider() {

    const [lastUpdate, setLastUpdate] = useState(null as Date);

    const network = useNetwork();   

    const operation = useOperation();   

    const updateAsync = async (isRefresh: boolean = false) => {

        const eventId = session.activeEvent?.id;

        if (!eventId)
            return;

        const now = new Date();

        if (isRefresh && lastUpdate &&
            appSettings.minStatsUpdateInterval &&
            (now.getTime() - lastUpdate.getTime()) / 1000 < appSettings.minStatsUpdateInterval) {

            operation.showAlert("Stai aggiornando troppo velocemente, riprova tra qualche secondo", "warning", 2000);
            return;
        }

        const event = await network(() => eventStore.getEventByIdAsync(eventId));
        lastStats = event.checkMode == EventCheckMode.Count ?
            await apiClient.getCountStatsAsync(eventId) :
            await apiClient.getScanStatsAsync(eventId);

        if (bySector && event.checkMode == EventCheckMode.Scan)
            lastStatsBySector = await network(() => apiClient.getScanStatsDetailsAsync(eventId));

        mode = event.checkMode;

        setLastUpdate(now);
    };

    const updateTimer = async () => {

        try {
            await updateAsync(true);
        }
        catch (err) {
            console.warn("Update stats error: ", err);
        }

        setTimeout(() => {

            if (isMounted)
                updateTimer();
        }, appSettings.monitorUpdateInterval);
    }


    useEffect(() => {

        isMounted = true

        updateTimer();

        return () => {
            isMounted = false
        }
    }, []);

    return {

        updateAsync,

        get mode() { return mode }, 
        
        get lastUpdate() { return lastUpdate }, 

        get lastStats() { return lastStats }, 

        get lastStatsBySector() { return lastStatsBySector }, 

        get eventId() { return session.activeEvent?.id },

        get bySector() { return bySector },

        set bySector(value: boolean) { bySector = value;  }  

    } as IEventStatsContext;
}